import styled from "styled-components";

import { NavLink } from "react-router-dom";

import CloseIcon from "@material-ui/icons/Close";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import MenuIcon from "@material-ui/icons/Menu";

interface IMenuContainer {
  toggle: boolean;
}

// geral
export const MenuContainer = styled.div<IMenuContainer>`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  max-width: ${({ theme }) => theme.siteWidth};
  font-weight: 600;
  font-family: ${props => props.theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSize.mm};
  height: 59px;
  @media ${({ theme }) => theme.devices.laptopL} {
    margin-right: 5px;
  }

  @media ${({ theme }) => theme.devices.tablet} {
    overflow: auto visible;
    position: fixed;
    height: 100%;
    padding: 0;
    margin-top: 0;

    top: 0;
    left: 0;
    z-index: 99999999 !important;
    background-color: ${({ theme }) => theme.colors.green.normal};
    transform: translateX(${({ toggle }) => (toggle ? "-100%" : "0")});
    width: max-content;
    transition: transform ${({ theme }) => theme.animation.duration};
    will-change: transform;
    flex-direction: column;
    font-size: ${({ theme }) => theme.fontSize.sm};
    align-items: start;

    justify-content: start;
    overflow: auto;
    &::-webkit-scrollbar {
      display: none;
    }
    scrollbar-width: none;
  }
`;

export const MenuItemContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  @media ${({ theme }) => theme.devices.tablet} {
    flex-direction: column;
    width: 100%;
  }
`;

export const MenuItem = styled.li`
  display: flex;
  flex-direction: column;
  position: relative;
  height: fit-content;
  align-items: center;
  justify-content: start;
  color: ${props => props.theme.colors.gray.dark};
  cursor: pointer;
  text-align: center;
  font-size: ${({ theme }) => theme.fontSizePx.md};
  width: fit-content;
  justify-content: space-between;

  svg {
    font-size: 1.5rem;
  }

  @media ${({ theme }) => theme.devices.laptopL} {
    font-size: ${({ theme }) => theme.fontSizePx.mm};
    margin: 5px;
  }

  @media (max-width: 1180px) {
    font-size: ${({ theme }) => theme.fontSizePx.mm};
    svg {
      font-size: 1.2rem;
    }
  }

  @media (max-width: 1080px) {
    font-size: ${({ theme }) => theme.fontSizePx.sm};
    svg {
      font-size: 0.95rem;
    }
  }

  @media ${({ theme }) => theme.devices.tablet} {
    width: auto;
    min-width: fit-content;
    padding: 10px;
    justify-content: start;
    margin: 0;
    margin-left: 20px;
    margin-right: 10px;
    background-color: ${props => props.theme.colors.green.normal};
    color: ${props => props.theme.colors.white.normal};
    flex-grow: 0;
    font-size: ${({ theme }) => theme.fontSize.md2};
    text-align: left;
    padding: 7px 0;
  }
`;

export const MenuItemLink = styled(NavLink)`
  display: flex;
  gap: 10px;
  align-items: center;
  width: 100%;
  text-decoration: none;
  font-family: ${props => props.theme.fonts.inter};
  color: ${props => props.theme.colors.grayNew.gray3};
  font-weight: 700;

  @media (max-width: 1260px) {
    gap: 5px;
  }

  @media ${({ theme }) => theme.devices.tablet} {
    gap: 10px;
  }

  &:hover {
    color: ${props => props.theme.colors.green.dark};
  }

  &.active {
    color: ${props => props.theme.colors.green.normal};
  }

  @media ${({ theme }) => theme.devices.tablet} {
    flex-direction: row;
    justify-content: start;
    color: ${props => props.theme.colors.white.normal};

    &.active {
      color: ${props => props.theme.colors.gray.dark};
      pointer-events: none;
    }
  }
`;

export const MenuItemIcon = styled.span`
  display: inline-block;
`;

interface ISubmenuContainer {
  expand: boolean;
  hover: boolean;
}

export const SubmenuContainer = styled.div<ISubmenuContainer>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  box-sizing: border-box;
  width: 100%;
  min-width: max-content;
  border-radius: 9px;
  padding: ${({ hover }) => (hover ? "12px 24px" : "0")};
  transform: translateY(-2px);
  background-color: ${props => props.theme.colors.white.normal};
  transition: max-height ${({ theme }) => theme.animation.duration};
  transition: padding ${({ theme }) => theme.animation.duration};
  transition: opacity ${({ theme }) => theme.animation.duration};
  will-change: max-height;
  margin-top: 2px;
  @media ${({ theme }) => theme.devices.laptop} {
    position: absolute;
    background-color: ${props => props.theme.colors.white.normal};
    box-shadow: ${props => props.theme.shadow.vertical};
    justify-content: flex-start;
    top: 100%;
    left: 0;
    right: 0;
    max-height: ${({ hover }) => (hover ? "70vh" : "0")};
    flex-wrap: wrap;
    opacity: ${({ hover }) => (hover ? "1" : "0")};
    display: flex;
    flex-direction: column;
  }
  @media ${({ theme }) => theme.devices.tablet} {
    background-color: ${props => props.theme.colors.green.medium};
    flex-direction: column;
    max-height: ${({ expand }) => (expand ? "100vh" : "0")};
    opacity: ${({ expand }) => (expand ? "1" : "0")};
  }

  @media ${({ theme }) => theme.devices.laptop} {
    flex-direction: column;
  }
`;

export const SubmenuCategory = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: column;
  margin: 5px 36px 5px 5px
  padding: 0;
  @media ${({ theme }) => theme.devices.tablet} {
    margin: 0;
    position: relative;
  }
`;

export const SubmenuCategoryTitle = styled(NavLink)`
  color: ${({ theme }) => theme.colors.gray.normal};
  padding: 0 0 4px 0;
  text-align: left;
  text-decoration: none;
  font-family: ${props => props.theme.fonts.inter};
  font-size: ${({ theme }) => theme.fontSizePx.mm};

  &:hover {
    color: ${props => props.theme.colors.green.dark};
  }

  @media ${({ theme }) => theme.devices.tablet} {
    position: relative;
    color: ${props => props.theme.colors.gray.light};
    padding: 0;
    margin: 5px 25px;
    justify-content: center;
    flex-direction: column;
    display: flex;
    height: 25px;
  }
  @media ${({ theme }) => theme.devices.mobileM} {
    font-size: ${({ theme }) => theme.fontSizePx.mm};
    margin: 2px 25px;
  }
`;

interface ISubmenuItemContainer {
  expand: boolean;
}

export const SubmenuItemContainer = styled.div<ISubmenuItemContainer>`
  @media ${({ theme }) => theme.devices.tablet} {
    max-height: ${({ expand }) => (expand ? "300px" : "0")};
    transition: max-height ${({ theme }) => theme.animation.duration};
    will-change: max-height;
    overflow: hidden;
  }
`;

export const SubmenuItem = styled.li`
  color: ${props => props.theme.colors.gray.dark};
  padding: 0 0 5px 0;
  text-align: left;

  &:hover {
    color: ${props => props.theme.colors.green.normal};
  }

  @media ${({ theme }) => theme.devices.tablet} {
    background-color: ${props => props.theme.colors.green.normal};
    color: ${props => props.theme.colors.gray.normal};
    flex-direction: column;
  }
`;

export const MobileToggle = styled(MenuIcon).attrs(props => ({
  fontSize: "large",
}))`
  font-size: 40px;
  color: ${props => props.theme.colors.gray.normal};
`;

export const MenuCloseContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  height: 100%;
`;

export const MenuClose = styled(CloseIcon).attrs(props => ({
  fontSize: "large",
}))`
  font-size: 40px;
  z-index: 999999999;
  color: ${({ theme }) => theme.colors.white.normal};
  position: fixed;
`;
export const ExpandContainer = styled.div`
  position: absolute;
  bottom: auto;
  left: auto;
  color: ${({ color, theme }) => (color ? color : theme.colors.green.light)};
  pointer-events: all;
  z-index: 30;
`;

export const ExpandMore = styled(ExpandMoreIcon)``;

export const ExpandLess = styled(ExpandLessIcon)``;

export const Logout = styled.li`
  text-decoration: none;
  font-size: ${({ theme }) => theme.fontSize.mm};
  color: ${({ theme }) => theme.colors.green.dark};
  margin-top: auto;
  padding: 30px;
  text-align: right;
`;

export const Publish = styled.li`
  margin-left: auto;
  padding: 10px 22px 10px 22px;
  background-color: ${({ theme }) => theme.colors.orange.normal};
  color: ${({ theme }) => theme.colors.white.normal};
  border-radius: 5px;
  margin-bottom: 10px;
  font-size: ${({ theme }) => theme.fontSize.sm};
  cursor: pointer;
  text-align: center;

  &:hover {
    background-color: ${({ theme }) => theme.colors.orange.light};
  }
`;

export const AnnounceContainer = styled.div`
  display: flex;

  @media ${({ theme }) => theme.devices.tablet} {
    display: none;
  }
`;

export const DividerVertical = styled.div`
  width: 1px;
  height: 25px;
  background-color: ${({ theme }) => theme.colors.grayNew.gray4};
  margin-left: 10px;
  @media ${({ theme }) => theme.devices.laptopM} {
    display: none;
    margin-left: 5px;
  }
`;
export const Buttonn = styled.button`
  padding: 10px 20px;
  text-align: center;
  text-wrap: nowrap;
  font-family: ${({ theme }) => theme.fonts.inter};
  font-size: ${({ theme }) => theme.fontSizePx.sm};
  font-weight: 600;
  color: ${({ theme }) => theme.colors.white.normal};
  border: none;
  border-radius: 6px;
  background-color: #ea7d24;
  margin-left: 10px;
  padding: 10px 10px;

  @media ${({ theme }) => theme.devices.laptopM} {
    padding: 10px 5px;
    margin-left: 5px;
    margin-right: 5px;

    font-size: ${({ theme }) => theme.fontSizePx.smm};
  }
  &:focus {
    outline: none;
  }
`;

export const HeaderContainer = styled.header`
  display: flex;
  height: 100%;
  flex-direction: row;
  max-width: ${({ theme }) => theme.siteWidth};
  margin: 0 auto;
  justify-content: space-between;
  align-items: center;
  position: relative;
`;

export const ProfileContainer = styled.div`
  display: flex;
  width: 100%;
  heigth: min-content;
  justify-content: flex-end;
`;

export const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999999; // logo abaixo do Menu que tem z-index: 99999999
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(2px);
`;
